import React, { useContext } from "react";
import { getAppConfig } from "@config/appConfig";
import { ApplicationContext } from "@context/ApplicationContext";
import "./style.scss";

const LetsGetStartedContent = () => {
    const { whiteLabel } = useContext(ApplicationContext);
    const config = getAppConfig();
    const getStarted = whiteLabel?.subscriber_group?.subscriber_group_get_started;

    const image1 = "asset/img/lets-get-started-1.webp";
    const image2 = "asset/img/lets-get-started-2.webp";
    const image3 = "asset/img/lets-get-started-3.webp";
    const image1Url = config?.cdnUrl ? config?.cdnUrl + image1 : `/${image1}`;
    const image2Url = config?.cdnUrl ? config?.cdnUrl + image2 : `/${image2}`;
    const image3Url = config?.cdnUrl ? config?.cdnUrl + image3 : `/${image3}`;

    const norm = (v) => (typeof v === "string" ? v.trim() : "");

    const apiImg1 = norm(getStarted?.image_one_url);
    const apiImg2 = norm(getStarted?.image_two_url);
    const apiImg3 = norm(getStarted?.image_three_url);

    const resolveUrl = (u, fallback) => {
        const v = norm(u);
        if (!v) return fallback;
        // Absolute URL (http/https or protocol-relative)
        if (/^https?:\/\//i.test(v) || v.startsWith("//")) return v;
        // Relative or root-relative path
        const pathNoLeadSlash = v.startsWith("/") ? v.slice(1) : v;
        return config?.cdnUrl ? config?.cdnUrl + pathNoLeadSlash : `/${pathNoLeadSlash}`;
    };

    const img1Src = resolveUrl(apiImg1, image1Url);
    const img2Src = resolveUrl(apiImg2, image2Url);
    const img3Src = resolveUrl(apiImg3, image3Url);

    const h1 = norm(getStarted?.header_one);
    const p1 = norm(getStarted?.paragraph_one);
    const h2 = norm(getStarted?.header_two);
    const p2 = norm(getStarted?.paragraph_two);
    const h3 = norm(getStarted?.header_three);
    const p3 = norm(getStarted?.paragraph_three);

    const show1 = !!(h1 || p1);
    const show2 = !!(h2 || p2);
    const show3 = !!(h3 || p3);

    const h1Style = getStarted?.header_one_color ? { color: getStarted.header_one_color } : undefined;
    const p1Style = getStarted?.paragraph_one_color ? { color: getStarted.paragraph_one_color } : undefined;

    const h2Style = getStarted?.header_two_color ? { color: getStarted.header_two_color } : undefined;
    const p2Style = getStarted?.paragraph_two_color ? { color: getStarted.paragraph_two_color } : undefined;

    const h3Style = getStarted?.header_three_color ? { color: getStarted.header_three_color } : undefined;
    const p3Style = getStarted?.paragraph_three_color ? { color: getStarted.paragraph_three_color } : undefined;

    if (!show1 && !show2 && !show3) return null;

    return (
        <div className="lets-get-started-content__container">
            {show1 && (
                <div className="lets-get-started__content">
                    <div className="lets-get-started-content__block lets-get-started-content__block--alt">
                        <div className="lets-get-started-content__img-wrapper">
                            <img
                                className="lets-get-started-content__img"
                                src={img1Src}
                                alt="Lets Gets Started Image 1"
                                loading="lazy"
                            />
                        </div>
                    </div>
                    <div className="lets-get-started-content__block">
                        {h1 && (
                            <h2 className="lets-get-started__title" style={h1Style}>
                                {h1}
                            </h2>
                        )}
                        {p1 && (
                            <p className="lets-get-started__text" style={p1Style}>
                                {p1}
                            </p>
                        )}
                    </div>
                </div>
            )}

            {show2 && (
                <div className="lets-get-started__content">
                    <div className="lets-get-started-content__block">
                        <div className="lets-get-started-content__img-wrapper">
                            <img
                                className="lets-get-started-content__img"
                                src={img2Src}
                                alt="Lets Gets Started Image 2"
                                loading="lazy"
                            />
                        </div>
                    </div>
                    <div className="lets-get-started-content__block">
                        {h2 && (
                            <h2 className="lets-get-started__title" style={h2Style}>
                                {h2}
                            </h2>
                        )}
                        {p2 && (
                            <p className="lets-get-started__text" style={p2Style}>
                                {p2}
                            </p>
                        )}
                    </div>
                </div>
            )}

            {show3 && (
                <div className="lets-get-started__content">
                    <div className="lets-get-started-content__block lets-get-started-content__block--alt">
                        <div className="lets-get-started-content__img-wrapper">
                            <img
                                className="lets-get-started-content__img"
                                src={img3Src}
                                alt="Lets Gets Started Image 3"
                                loading="lazy"
                            />
                        </div>
                    </div>
                    <div className="lets-get-started-content__block">
                        {h3 && (
                            <h2 className="lets-get-started__title" style={h3Style}>
                                {h3}
                            </h2>
                        )}
                        {p3 && (
                            <p className="lets-get-started__text" style={p3Style}>
                                {p3}
                            </p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default LetsGetStartedContent;
